$(document).ready(function () {
  $('.header__menu-item').each(function () {
    const $menuItem = $(this);
    const $details = $menuItem.closest('details');
    if (!$details.length) return;

    $menuItem.on('click', function (e) {
      if ($details.prop('open')) {
        e.preventDefault();
      }
    });

    $menuItem.on('mouseenter', function () {
      $details.prop('open', true);
      $menuItem.attr('aria-expanded', 'true');
    });

    $details.on('mouseleave', function () {
      $details.prop('open', false);
      $menuItem.attr('aria-expanded', 'false');
    });
  });
});
